import React, { useContext } from "react";
import { directoryContext } from "../../context/Context";
import Ratings from "./Ratings";
import axios from "axios";

const CommentForm = ({ setShow, listingId }) => {
  const [comment, setComment] = React.useState("");
  const [rating, setRating] = React.useState(0);
  const {
    reviewDispatch,
    userState: { user },
  } = useContext(directoryContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!user) return alert("Please login to leave a comment");
      if (!comment) return alert("Please enter a comment");
      if (rating < 1) return alert("Please choose your desired  rating");

      const data = {
        review: comment,
        user: user,
        listingId: listingId,
        rating: rating,
      };
      const res = await axios.post(
        "https://www.api.webdirectories.info/api/review",
        data
      );
      if (res.status === 200) {
        alert("Review added successfully");
        setComment("");
        reviewDispatch({ type: "ADD_REVIEW", payload: res.data });
        setShow(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onClick = (i) => {
    setRating(i + 1);
  };

  return (
    <div className="bg-white py-4  px-3">
      {/* <h4
      style={{
        fontSize: "1.154rem",
        fontWeight: "600",
        color: "#566985",
      }}
    >
      Add Comment
    </h4> */}
      <p className="font-weight-bold text-secondary text-center">
        Your email is safe with us.
      </p>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <div className="form-group ">
              <textarea
                className="form-control myInput customArea"
                id="exampleFormControlTextarea1"
                rows="3"
                placeholder="Your Comment :"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              {/* <input
              type="text"
              className="form-control myInput"
              id="exampleFormControlInput1"
              placeholder="Your Name *"
              value={user&& user.name}
              readOnly
              style={{ marginRight: "10px" }}
            /> */}
              {/* <input
              type="email"
              value={user&& user.email}
              readOnly
              className="form-control myInput"
              id="exampleFormControlInput1"
              placeholder="Your Email *"
              style={{ marginLeft: "10px" }}
            /> */}
              <div>
                <Ratings rating={rating} onClick={onClick} />
              </div>
            </div>
            <input type="checkbox" defaultChecked className="mt-5 mx-2" />
            <span className="text-danger ">
              Save my name, email, and website in this browser for the next time
              I comment.
            </span>
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <button
              type="button"
              className="btn mt-3 px-2 py-2 font-weight-bold"
              style={{
                background: "#5ECFB1",
                color: "#fff",
                fontSize: "15px",
              }}
              onClick={handleSubmit}
            >
              Submit
            </button>
            <button
              className="btn btn-danger mt-3 mx-3 px-2 py-2 font-weight-bold"
              type="button"
              onClick={() => setShow(false)}
              style={{
                // background: "#566985",
                color: "#fff",
                fontSize: "15px",
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CommentForm;
